<template>
	<div v-if="difficulty" class="flex gap-4 items-center">
		<span
			class="
				block
				relative
				h-[1.125rem]
				w-[3.875rem]
				lg:w-[7.75rem]
				bg-background-primary
				rounded-full
				before:absolute
				before:inset-y-0
				before:w-[0.125rem]
				before:bg-background-primary
				before:left-1/3
				before:z-10

				after:absolute
				after:inset-y-0
				after:w-[0.125rem]
				after:bg-background-primary
				after:left-2/3
				after:z-10
			"
			:style="`background: linear-gradient(90deg, rgb(211, 69, 0) 0%, rgb(211, 69, 0) ${gradientPercentage}%, rgb(244, 244, 244) ${gradientPercentage}%, rgb(244, 244, 244) 100%);`"
			aria-label="Obtížnost přípravy"
		/>
		{{ value }}
	</div>
</template>

<script setup lang="ts">
	interface Props {
		difficulty: number,
		value: string,
	}

	const props = defineProps<Props>();
	const gradientPercentage = computed(() => props.difficulty === 3 ? 100 : (props.difficulty === 2 ? 66.67 : 33.33));
</script>
